import { generatePath } from 'react-router-dom';

import { PATHS } from '@/shared/constants/routes/paths';

export const getProjectPath = (id: string, spaceId: string, canNavigate?: boolean) => {
  if (!canNavigate) {
    return;
  }

  return generatePath(`/${PATHS.spaces}/${spaceId}/${PATHS.project}/:id`, { id });
};
